import { action } from '@ember/object';
import { type Registry as Services, service } from '@ember/service';
import Component from '@glimmer/component';
import { PrismButton } from '@mylighthouse/prism-ember';
import { t } from 'ember-intl';
import { openUrl } from 'frontend-utils/utils/url/open-url';
import HotelStrategySubtypeHeader from 'lumen/components/hotel/strategy/subtype-header';
import { MEALTYPE_TRANSLATION_KEYS } from 'lumen/utils/constants/general-constants';
import { createCompareRedirectUrl } from 'lumen/utils/strategy/detail-view-helpers';

interface HotelStrategyTablesCellsThStrategyDetailSignature {
  Args: {
    column: unknown;
  };
}

export default class HotelStrategyTablesCellsThStrategyDetail extends Component<HotelStrategyTablesCellsThStrategyDetailSignature> {
  @service declare ajax: Services['ajax'];
  @service('hotel-and-market')
  declare hotelAndMarketService: Services['hotel-and-market'];
  @service declare router: Services['router'];
  @service declare rsSelections: Services['rs-selections'];

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get columnKey() {
    // @ts-expect-error: Incorrect type
    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this.args.column.columnKey;
  }

  // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
  get redirectUrl() {
    return createCompareRedirectUrl(
      this.ajax.host,
      this.router.currentRouteName,
      this.columnKey,
      // @ts-expect-error: Incorrect type
      this.args.column.subtypeHeaderAttributes,
      this.rsSelections.shouldRedirectToSecondaryCompset,
      this.hotelAndMarketService,
    );
  }

  @action
  redirectToCompare(): void {
    // @ts-expect-error: Incorrect type
    const { subtypeHeaderAttributes } = this.args.column;

    // E.g.: roomtype.single / cancellation.non_ref
    if (this.columnKey) {
      // Try to give decent name for mealtypes instead of id like 5
      if (
        this.router.currentRouteName === 'hotel.strategy.mealtype' &&
        // @ts-expect-error: Incorrect type
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        MEALTYPE_TRANSLATION_KEYS[this.columnKey].split('.').length === 3
      ) {
        // Removed unused variable `routeAndColumnIdentifier`
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (subtypeHeaderAttributes?.isMobileBookingSubtype) {
        // Removed unused variable `routeAndColumnIdentifier`
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      } else if (subtypeHeaderAttributes?.isMobileExpediaSubtype) {
        // Removed unused variable `routeAndColumnIdentifier`
      } else {
        // Removed unused variable `routeAndColumnIdentifier`
      }
    }

    openUrl(this.redirectUrl);
  }

  <template>
    {{! @glint-nocheck }}
    <div
      class="text-200--bold
        {{if
          @column.hasCompareButton
          'flex items-center justify-between'
          'flex justify-start'
        }}"
    >
      {{#if @column.subtypeHeaderAttributes}}
        <HotelStrategySubtypeHeader
          @formattedLabel={{@column.subtypeHeaderAttributes.formattedLabel}}
          @isBranddotcomMemberRatesSubType={{@column.subtypeHeaderAttributes.isBranddotcomMemberRatesSubType}}
          @isMealtypeType={{@column.subtypeHeaderAttributes.isMealtypeType}}
          @isMemberRatesType={{@column.subtypeHeaderAttributes.isMemberRatesType}}
          @isMobileBookingSubtype={{@column.subtypeHeaderAttributes.isMobileBookingSubtype}}
          @isMobileExpediaSubtype={{@column.subtypeHeaderAttributes.isMobileExpediaSubtype}}
          @isMobileHotelsDotComSubtype={{@column.subtypeHeaderAttributes.isMobileHotelsDotComSubtype}}
          @isPosBookingSubtype={{@column.subtypeHeaderAttributes.isPosBookingSubtype}}
          @isPosExpediaSubtype={{@column.subtypeHeaderAttributes.isPosExpediaSubtype}}
          @label={{@column.subtypeHeaderAttributes.label}}
        />
      {{else}}
        {{@column.name}}
      {{/if}}

      {{#if @column.hasCompareButton}}
        <PrismButton
          @buttonType="secondary"
          @iconBefore="compare"
          @label={{t "general.compare"}}
          @onClick={{this.redirectToCompare}}
          @size="small"
        />
      {{/if}}
    </div>
  </template>
}
